import { useQuery } from '@tanstack/react-query';
import { axiosInstance } from '../../utils';

interface Payload {
  videoId: string;
}

export const validateMediaStatus = async (payload: Payload): Promise<any> => {
  const res = await axiosInstance.get(`/api/remotion/validateMediaStatus/${payload.videoId}`,);
  return res.data;
};
